module.exports = __webpack_public_path__ + "img/crypto_masters_logo_withText_rounded.9c875ada.svg";